<template>
    <div class="address" ref="addressContainer">
        <div
            class="address_container"
            v-for="(address, index) in addresses"
            :class="[
                address.gradient,
                { [draggedIndexClass]: index === draggedIndex, [previewIndexClass]: index === previewIndex },
            ]"
            :key="index"
            ref="draggedElement"
        >
            <!-- AddressChoosePopup -->

            <div class="draggedContent">
                <div style="display: flex">
                    <div class="address_number drag-handle">
                        <span>{{ index + 1 }}</span>
                        <svg
                            :id="'id_' + index"
                            width="40"
                            height="30"
                            viewBox="0 0 40 30"
                            fill="white"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect width="30" height="30" rx="4" />
                            <path d="M39.1602 15L26.0762 18.9039L26.0762 11.0961L39.1602 15Z" />
                        </svg>
                    </div>
                    <label
                        :class="['address_number', 'id_' + index]"
                        style="
                            width: unset;
                            margin-top: auto;
                            margin-bottom: auto;
                            font-size: 24px;
                            color: var(--color-number);
                        "
                    >
                        {{ address.type == 'from' ? 'ОТКУДА' : address.type == 'to' ? 'КУДА' : 'КУДА' }}
                    </label>
                </div>
                <div class="input_addresses_container">
                    <div class="input_addresses">
                        <CInput
                            :name="'address_' + index"
                            :id="'address_' + index"
                            class="input_address"
                            v-model="address.value"
                            :label="address.placeholder"
                            @click="(ev) => openMap(index, address.suggestion, ev)"
                            @clear="handleClear(index)"
                            @error="handleInputError"
                            :maxPercent="index == 0 || index == addresses.length - 1 ? maxPercent / 2 : 0"
                            clearable
                            required
                        />

                        <AddressChoosePopup :placeholder="address.placeholder" :ref="'addressChoosePopup' + index" @gis-api-call="$emit('gis-api-call')" />

                        <div
                            class="addresses_floor"
                            :class="{
                                expanded: address.floor >= 2 || (address.floor < 0 && address.floor != ''),
                                expanded2:
                                    address.floor >= 2 ||
                                    (address.floor < 0 &&
                                        address.floor != '' &&
                                        address.elevatorsAvailable.find(
                                            (item) => item.checked && item.value == 'true'
                                        )),
                            }"
                        >
                            <div style="display: flex; align-items: center">
                                <label class="checkboxes_head">Этаж</label>
                                <CInput
                                    name="floor"
                                    id="floor"
                                    type="floor"
                                    class="input_floor input_nopaddings keep_placeholder"
                                    style="width: 35px; height: 35px"
                                    :mask="tools.formatNumber(99, -99)"
                                    v-model="address.floor"
                                    @error="handleInputError"
                                    placeholder="1"
                                />
                            </div>
                            <div
                                v-if="address.floor >= 2 || (address.floor < 0 && address.floor != '')"
                                class="elevators"
                            >
                                <label class="checkboxes_head">Лифт</label>
                                <CheckboxGroup
                                    name="address"
                                    className=""
                                    :checkboxes="address.elevatorsAvailable"
                                    maxSelected="1"
                                    requiredCount="1"
                                    @error="handleInputError"
                                />
                            </div>
                            <div
                                v-if="
                                    (address.floor >= 2 || address.floor > 0) &&
                                    address.floor != '' &&
                                    address.elevatorsAvailable.find((item) => item.checked && item.value == 'true')
                                "
                                class="elevators"
                            >
                                <label class="checkboxes_head">Грузовой</label>
                                <CheckboxGroup
                                    name="address"
                                    className=""
                                    :checkboxes="address.elevatorsType"
                                    maxSelected="1"
                                    requiredCount="1"
                                    @error="handleInputError"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="address_controls">
                        <div
                            class="adress_buttons delete"
                            v-if="addresses.length > 2 && index >= 1"
                            @click="removeAddress(index)"
                        >
                            <svg
                                width="22"
                                height="29"
                                viewBox="0 0 22 29"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.55556 25.3889C1.55556 26.214 1.88333 27.0053 2.46678 27.5888C3.05023 28.1722 3.84155 28.5 4.66667 28.5H17.1111C17.9362 28.5 18.7276 28.1722 19.311 27.5888C19.8944 27.0053 20.2222 26.214 20.2222 25.3889V6.72222H1.55556V25.3889ZM5.38222 14.3133L7.57556 12.12L10.8889 15.4178L14.1867 12.12L16.38 14.3133L13.0822 17.6111L16.38 20.9089L14.1867 23.1022L10.8889 19.8044L7.59111 23.1022L5.39778 20.9089L8.69556 17.6111L5.38222 14.3133ZM16.3333 2.05556L14.7778 0.5H7L5.44444 2.05556H0V5.16667H21.7778V2.05556H16.3333Z"
                                    fill="#98A09F"
                                />
                            </svg>
                        </div>
                        <div
                            class="adress_buttons swap"
                            @mousedown="startDrag(index, $event)"
                            @mousemove="handleDragImitation($event)"
                            @mouseup="stopDragImitation"
                        >
                            <img src="@/assets/IMGS/SVG/drag_gray.svg" style="pointer-events: none" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="maxAddreses > 0"
            class="adress_buttons add_addresses"
            :class="{ disabled: addresses.length > maxAddreses }"
            @click="addIntermediateAddress()"
        >
            <div>+</div>
            <span>Добавить дополнительный адрес</span>
        </div>
    </div>
</template>

<script>
import CInput from './InputComponent.vue';
import AddressChoosePopup from './AddressChoosePopup.vue';
import CheckboxGroup from './CheckboxComponent.vue';
import tools from '@/assets/js/tools.js';

export default {
    name: 'AddressesBox',

    emits: ['gis-api-call', 'addresses-data'],
    
    components: {
        CInput,
        AddressChoosePopup,
        CheckboxGroup,
    },
    props: {
        maxAddreses: {
            type: Number,
            default: 3,
        },
        maxPercent: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            tools: tools,
            addresses: this.getDefaultAddresses(),
            draggedIndex: null,
            previewIndex: null,
            draggedIndexClass: 'dragged',
            previewIndexClass: 'preview',
            initialMouseY: 0,
            isDragging: false,
            draggedContent: null,
        };
    },
    watch: {
        addresses: {
            handler: function (newAddresses) {
                this.$emit('addresses-data', newAddresses);
            },
            deep: true,
        },
    },
    created() {
        this.isMobile = this.getMobileScreen();
        this.createCheckboxes();
    },
    methods: {
        getMobileScreen() {
            if (screen.width <= 1024) {
                return true;
            } else {
                return false;
            }
        },
        getDefaultAddresses() {
            return [
                {
                    placeholder: 'Откуда',
                    type: 'from',
                    value: '',
                    floor: '',
                    gradient: 'gradient_from',
                    elevatorsAvailable: [],
                    elevatorsType: [],
                },
                {
                    placeholder: 'Куда',
                    type: 'to',
                    value: '',
                    floor: '',
                    gradient: 'gradient_to',
                    elevatorsAvailable: [],
                    elevatorsType: [],
                },
            ];
        },
        createCheckboxes() {
            this.addresses.forEach((address, index) => {
                this.addresses[index].elevatorsAvailable = this.createCheckboxItems('elevatorsAvailable', index);
                this.addresses[index].elevatorsType = this.createCheckboxItems('elevatorsType', index);
            });
        },
        createCheckboxItems(type, index, existingItems = []) {
            return [
                {
                    id: `${type}1_${index}`,
                    name: `${type}_${index}`,
                    value: 'true',
                    label: 'Да',
                    checked: existingItems[0] ? existingItems[0].checked : false,
                },
                {
                    id: `${type}2_${index}`,
                    name: `${type}_${index}`,
                    value: 'false',
                    label: 'Нет',
                    checked: existingItems[1] ? existingItems[1].checked : true,
                },
            ];
        },
        handleInputError({ hasError, name, percent }) {
            this.$emit('error', { hasError, name, percent });
        },
        openMap(index, currentSuggestion) {
            var vm = this;
            vm.$refs['addressChoosePopup' + index][0].myOpen((data) => {
                vm.addresses[index].suggestion = data;
                if (Object.keys(data).length === 0) {
                    vm.addresses[index].value = '';
                } else {
                    vm.addresses[index].value = data.label;
                }
            }, currentSuggestion);
        },
        handleClear(index) {
            this.$refs['addressChoosePopup' + index][0].handleClear();
        },
        updateAddress(index, value) {
            this.addresses[index].value = value;
        },
        updateFloor(index, value) {
            this.addresses[index].floor = value;
        },
        addIntermediateAddress() {
            if (this.addresses.length <= 3) {
                const intermediateAddress = {
                    placeholder: 'Куда',
                    type: 'to',
                    value: '',
                    floor: '',
                    gradient: 'gradient_to',
                    elevatorsAvailable: this.createCheckboxItems('elevatorsAvailable', this.addresses.length),
                    elevatorsType: this.createCheckboxItems('elevatorsType', this.addresses.length),
                };
                var lastIndex = this.addresses.length - 1;
                this.addresses[lastIndex].type = 'intermediate';
                this.addresses[lastIndex].placeholder = 'Куда';
                this.addresses[lastIndex].gradient = 'gradient_intermediate';
                this.addresses.push(intermediateAddress);
            }
        },
        removeAddress(index) {
            if (index >= 0 && index < this.addresses.length) {
                const removedAddressType = this.addresses[index].type;
                this.addresses.splice(index, 1);

                if (this.addresses.length > 0) {
                    const lastIndex = this.addresses.length - 1;

                    if (removedAddressType === 'intermediate') {
                        this.addresses[lastIndex].type = 'to';
                        this.addresses[lastIndex].placeholder = 'Куда';
                        this.addresses[lastIndex].gradient = 'gradient_to';
                    } else if (removedAddressType === 'to') {
                        this.addresses[lastIndex].type = 'to';
                        this.addresses[lastIndex].placeholder = 'Куда';
                        this.addresses[lastIndex].gradient = 'gradient_to';
                    }
                }
            }
        },
        startDrag(index, event) {
            this.draggedIndex = index;
            this.initialMouseY = event.clientY;
            this.isDragging = true;
            this.draggedContent = this.$refs.draggedElement[index];
            this.draggedContent.classList.add(this.draggedIndexClass);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.stopDrag);
        },
        handleDrag(event) {
            if (this.isDragging) {
                const offsetY = event.clientY - this.initialMouseY;
                const translateY = offsetY + 'px';
                this.draggedContent.style.transform = `translateY(${translateY})`;

                const newIndex = this.calculateNewIndex(event.clientY);
                this.previewIndex = newIndex;
            }
        },
        stopDrag() {
            if (this.isDragging && this.previewIndex !== null && this.addresses[this.previewIndex]) {
                const draggedValue = this.addresses[this.draggedIndex].value;
                const draggedFloor = this.addresses[this.draggedIndex].floor;
                const draggedElevatorsAvailable = [...this.addresses[this.draggedIndex].elevatorsAvailable];
                const draggedElevatorsType = [...this.addresses[this.draggedIndex].elevatorsType];
                const draggedsuggestion = this.addresses[this.draggedIndex].suggestion;

                this.addresses[this.draggedIndex] = {
                    ...this.addresses[this.draggedIndex],
                    value: this.addresses[this.previewIndex].value,
                    floor: this.addresses[this.previewIndex].floor,
                    elevatorsAvailable: [...this.addresses[this.previewIndex].elevatorsAvailable],
                    elevatorsType: [...this.addresses[this.previewIndex].elevatorsType],
                    suggestion: this.addresses[this.previewIndex].suggestion,
                };

                this.addresses[this.previewIndex] = {
                    ...this.addresses[this.previewIndex],
                    value: draggedValue,
                    floor: draggedFloor,
                    elevatorsAvailable: draggedElevatorsAvailable,
                    elevatorsType: draggedElevatorsType,
                    suggestion: draggedsuggestion
                };
            }

            this.draggedIndex = null;
            this.previewIndex = null;
            this.isDragging = false;

            // Возвращаем элемент на место
            this.draggedContent.style.transform = 'translateY(0)';
            this.draggedContent.removeAttribute('style');
            this.draggedContent.classList.remove(this.draggedIndexClass);

            // Удаляем обработчики событий на уровне документа
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.stopDrag);
        },
        calculateNewIndex(y) {
            const rect = this.$refs.addressContainer.getBoundingClientRect(); // Use $refs to get the element
            const relativeY = y - rect.top;
            const index = Math.floor((relativeY / rect.height) * this.addresses.length);
            return Math.min(this.addresses.length - 1, Math.max(0, index));
        },
        handleDragImitation(event) {
            if (this.isDragging) {
                const offsetY = event.clientY - this.initialMouseY;
                const translateY = offsetY + 'px';
                this.draggedContent.style.transform = `translateY(${translateY})`;
            }
        },
        stopDragImitation() {
            if (this.isDragging && this.draggedContent) {
                this.draggedContent.style.transform = 'translateY(0)';
                this.draggedContent.removeAttribute('style');
            }
        },
        saveLocalStorage(name) {
            this.tools.saveForm(name, this.addresses);
        },
        loadLocalStorage(name) {
            var loaded_data = this.tools.loadForm(name);
            if (loaded_data) {
                this.addresses = loaded_data;
            }
        },
        resetValues() {
            this.addresses = this.getDefaultAddresses();
            this.createCheckboxes();
        },
    },
};
</script>

<style scoped lang="scss">
.address_container {
    display: flex;
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 20px;
    margin-bottom: 27px;
    border-radius: 10px;
    transition: background-color 0.3s ease;
    position: relative; /* Добавьте position: relative; для корректного отображения z-index */
    transition-duration: 0.25s;

    @media screen and (min-width: 992px) {
        padding-top: 30px;
    }

    @media screen and (min-width: 1200px) {
        margin-bottom: 43px;
    }
}

.address_container.dragged {
    z-index: 2; /* Устанавливаем высший z-index для dragged */
    cursor: grabbing;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    user-select: none;
    transition-duration: 0.25s;
}

.address_container.preview {
    cursor: grabbing;
    box-sizing: border-box;
    user-select: none;
    transition-duration: 0.25s;
}

.draggedContent {
    display: flex;
    flex-direction: column;
    width: 100%;
    transition-duration: 0.25s;

    @media screen and (min-width: 992px) {
        flex-direction: row;
    }
}

.addresses_floor {
    display: flex;
    flex-direction: column;
    gap: 12px 60px;
    margin-top: 10px;
    align-items: stretch;
    height: 40px;
    padding-top: 1px;
    overflow-y: clip;
    transition: height 0.3s ease-in-out;

    &.expanded {
        height: 70px;
    }

    @media screen and (max-width: 991px) {
        &.expanded2 {
            height: 120px;
        }
    }

    .elevators {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    @media screen and (min-width: 992px) {
        flex-direction: row;
        align-items: baseline;

        .elevators {
            align-items: start;
        }

        .ui-radio-group {
            flex-direction: column;
        }
    }
}

.address_number {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 69px;
}
.address_number span {
    z-index: 1;
    display: flex;
    margin-left: -10px;
    color: var(--color-white);
    font-weight: 600;
}

.address_number #id_0,
.address_number.id_0 {
    --color-number: #a2ddfe;
}

@media screen and (min-width: 992px) {
    .address_number.id_0,
    .address_number.id_1,
    .address_number.id_2,
    .address_number.id_3 {
        display: none;
    }
}

.address_number {
    --color-number: #ff8a90;
}

.address_number svg rect,
.address_number svg path {
    fill: var(--color-number);
}

.address_number svg {
    z-index: 0;
    display: flex;
    position: absolute;
}

.input_addresses_container {
    display: flex;
    gap: 15px;
    width: 100%;
    position: relative;
}

.input_address {
    border: none;
}

.input_addresses {
    position: relative;
    display: flex;
    flex-flow: column;
    flex: 1 1 100%;
}

.address_controls {
    display: inline-flex;
    justify-content: center;
    gap: 15px;
    align-items: center;
    height: 72px;
    flex: 0 0 auto;
}

.address {
    width: 100%;
}

.address .gradient_from {
    background: linear-gradient(90deg, rgba(74, 172, 226, 0.1) 7.76%, rgba(238, 104, 112, 0.1) 99.18%);
}

.address .dragged.gradient_from {
    background-color: rgba(255, 255, 255, 1);
}

.address .gradient_to {
    background: linear-gradient(270deg, rgba(74, 172, 226, 0.1) 0%, rgba(238, 104, 112, 0.1) 100%);
}

.address .dragged.gradient_to {
    background-color: rgba(255, 255, 255, 1);
}

.address .gradient_intermediate {
    background: linear-gradient(270deg, rgba(74, 172, 226, 0.1) 0%, rgba(238, 104, 112, 0.1) 100%);
}

.address .dragged.gradient_intermediate {
    background-color: rgba(255, 255, 255, 1);
}

.adress_buttons {
    width: fit-content;
    height: fit-content;
    color: #ff8a90;
    transition-duration: 0.5s;
    border-radius: 5px;
    cursor: pointer;

    &.delete svg path {
        transition-duration: 0.5s;
    }

    &.delete:hover svg path {
        fill: #ff8a90;
        transition-duration: 0.5s;
    }

    &:hover.add_addresses {
        box-shadow: none;
    }

    @media screen and (max-width: 991px) {
        &.swap {
            display: none;
        }
    }
}

.add_addresses.disabled {
    cursor: not-allowed;
    color: #999;
}

.add_addresses.disabled span {
    text-decoration: underline dotted #999;
}

.add_addresses.disabled div {
    background: #999;
}

.add_addresses {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 11px;
}

.checkboxes_head {
    margin-top: 3px;
    margin-right: 15px;
    font-weight: 500;
    font-size: 18px;
}

.add_addresses div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    border-radius: 5px;
    font-size: 18px;
    font-weight: 900;
    margin-right: 10px;
    background: #ff8a90;
    color: #fff;
}

.add_addresses span {
    display: flex;
    line-height: 0px;
    font-size: 18px;
    text-decoration: underline dotted #ff8a90;
}
</style>
